import { Col, Row, Tabs, TabsProps } from "antd";
import { NeedHelp } from "../../../atoms/CustomIcons";
import DashboardTemplate from "../../../templates/Dashboard";
import DashboardHeader from "./Components/DashboardHeader";
import TabScopePricing from "./Components/DashboardTabs/TabScopePricing";
import TabWorkOrders from "./Components/DashboardTabs/TabWorkOrders";
import TabMaterials from "./Components/DashboardTabs/TabMaterials";
import TabTasks from "./Components/DashboardTabs/TabTasks";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { useEffect, useState } from "react";
import { getContractById, removeContractDetailData } from "../ducks/actions";
import TabJobCosting from "./Components/DashboardTabs/TabJobCosting";
import TabDashboard from "./Components/DashboardTabs/TabDashboard";
import RightSideBar from "./Components/RightSideBar";

export default function ContractDetails() {
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const [loading, setLoading] = useState(false);
  // const companyId = pathSegments[pathSegments.length - 1];
  const contractId = pathSegments[pathSegments.length - 2];

  const contractDetailData = useAppSelector(
    (state) => state?.contract?.contractDetailData
  );

  useEffect(() => {
    dispatch(removeContractDetailData());
  }, [dispatch]);

  useEffect(() => {
    if (contractId) {
      dispatch(getContractById(contractId));
    }
  }, [dispatch, contractId]);

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Dashboard",
      children: <TabDashboard />,
    },
    {
      key: "2",
      label: "Job costing",
      children: (
        <TabJobCosting jobCostingData={contractDetailData?.data?.jobCostings} />
      ),
    },
    {
      key: "3",
      label: "Scope & pricing",
      children: (
        <TabScopePricing
          contractId={contractId}
          proposalData={contractDetailData?.data?.current_accepted_proposal}
          currentAcceptedProposalId={
            contractDetailData?.data?.current_accepted_proposal_id
          }
          changeOrderData={contractDetailData?.data?.changeOrders}
        />
      ),
    },
    {
      key: "4",
      label: "Work orders",
      children: (
        <TabWorkOrders contractWOData={contractDetailData?.data?.workOrders} />
      ),
    },
    {
      key: "5",
      label: "Tasks",
      children: <TabTasks taskData={contractDetailData?.data?.tasks} />,
    },
    {
      key: "6",
      label: "Materials",
      children: (
        <TabMaterials
          contractMatData={contractDetailData?.data?.contract_materials}
        />
      ),
    },
    {
      key: "7",
      label: "Documents",
      disabled: true,
    },
  ];

  return (
    <DashboardTemplate loading={contractDetailData?.loader || loading}>
      <DashboardHeader
        breadcrumb={[
          { label: "Contracts", href: `` },
          { label: "Contract details" },
        ]}
        title={contractDetailData?.data?.name ?? ""}
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
        propertyName={contractDetailData?.data?.property?.name ?? ""}
        propertyClientName={
          contractDetailData?.data?.property?.client?.name ?? ""
        }
        detailData={contractDetailData?.data}
        loading={loading}
        setLoading={setLoading}
      />

      <div className="dashboard_wrapper contracts_dashboard_container">
        <Row gutter={16} wrap={false}>
          <Col span={18} className="left_area">
            <div className="tabsBox">
              <Tabs
                defaultActiveKey="1"
                items={items}
                className="dashboard_tabs"
              />
            </div>
          </Col>
          <Col span={6} className="right_area contract_right_sidebar">
            <RightSideBar sidebarData={contractDetailData?.data} />
          </Col>
        </Row>
      </div>
    </DashboardTemplate>
  );
}
